import { injectable } from 'tsyringe'
import { AdditionalInfoApiRepository } from '@/app/repositories/api/AdditionalInfoApiRepository'
import { AdditionalInfo } from '@/domain/entities/AdditionalInfo'
import {
  PostAdditionalInterface,
  UpdateAdditionalInterface,
  DeleteAdditionalInterface,
} from '@/data/payload/contracts/AdditionalInfoRequest'
@injectable()
export class AdditionalInfoPresenter {
  private repository: AdditionalInfoApiRepository

  constructor(repository: AdditionalInfoApiRepository) {
    this.repository = repository
  }

  public loadAdditionalInfo(params: Object): Promise<AdditionalInfo> {
    return this.repository.getAll(params)
  }

  public postAdditionalInfo(
    payload: PostAdditionalInterface
  ): Promise<AdditionalInfo> {
    return this.repository.post(payload)
  }

  public updateAdditionalInfo(
    payload: UpdateAdditionalInterface,
    id: number
  ): Promise<AdditionalInfo> {
    return this.repository.update(payload, id)
  }

  public deleteAdditionalInfo(
    payload: DeleteAdditionalInterface
  ): Promise<AdditionalInfo> {
    return this.repository.delete(payload)
  }
}
